import { render } from "./QuanTriSanPham.vue?vue&type=template&id=a20acbf8&scoped=true"
import script from "./QuanTriSanPham.vue?vue&type=script&lang=js"
export * from "./QuanTriSanPham.vue?vue&type=script&lang=js"

import "./QuanTriSanPham.vue?vue&type=style&index=0&id=a20acbf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20acbf8"]])

export default __exports__